import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setSubTitle } from "../stores/AppReducer";
import type { AppDispatch } from "../stores/AppStore";

function Authlink () {
    const dispatch = useDispatch<AppDispatch>();
    useEffect(() => {
        dispatch(setSubTitle("Digitaler-Schlüssel 🔑"));
    }, []);
    return (
        <div className="home">
            <p><i>Was ist das, ein Digitaler-Schlüssel?</i></p>
            <p>
                Der Digitaler-Schlüssel ist ein personalisierter Link auf diese Website, der eine 32 Zeichen lange Zeichenkette (Token),
                enthält.<br/>
                Du bekommst diesen Link mit einer Einladungs-Mail oder innerhalb eines Chats auf einer anderen Plattform.<br/>
                Du musst diesen Link gut vor fremdem Zugriff schützen.<br/>
            <p>
                Wenn Du den Link in Deinem Browser aufrufst, wird der Token in deinem Browser gespeichert.
                Damit hast Du von diesem Browser auf diesem Gerät ohne weitere Abfragen Zugriff auf diese Website.
                Auch dann, wenn Du den Browser schließt oder das Gerät zwischendurch auschaltest.  
            </p>
                Du kannst den Token jederzeit erneuern, z.B. wenn Du den Verdacht hast, dass ihn jemand kopiert hat.<br/>
                Unabhängig davon ist es ratsam, ihn von Zeit zu Zeit zu erneuern.<br/>
                Rufe dazu deine Profil-Seite auf, indem Du oben rechts auf Deinen Login-Namen klickst.
            </p>
            <p>
                Wenn Du mittels Digitalem-Schlüssel auf der Webseite eingeloggt bist 
                - Du siehst das an Deinem Namen der oben rechts anstatt 'Login' -
                dann kannst Du Dir auch ein eigenes Passwort einrichten.<br/>
                Dazu wird allerdings entweder Deine E-Mail-Adresse oder Deine Mobilnummer benötigt.<br/>
                Du erhälst dann entweder einen Link per E-Mail oder eine SMS mit einem Zahlencode.
                Damit bestätigst Du Deine Echtheit.
            </p>
            <p>
                Ohne eine Einladung, kannst Du hier nur das sehen, was ohnehin öffentlich ist.<br/>
                Auch mit Deinem persönlichen Digitalem-Schlüssel hast du zunächst nur Leserechte auf Resourcen, 
                die für Dich frei gegeben sind.
                In der Kopfzeile rechts steht dann (<i>nur lesen</i>). Wurde deine Echtheit einmal geprüft, 
                dann verschwindet diese Anzeige. Damit kannst Du z.B. im Chat auch etwas schreiben.<br/>
            </p>
        </div>
    );
};
export default(Authlink);